/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const deleteApiOfficesIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
});

/**
 * @description OK
 */
export const deleteApiOfficesId200Schema = z.any();

export const deleteApiOfficesIdMutationResponseSchema = z.lazy(
  () => deleteApiOfficesId200Schema,
);
